module.exports = __webpack_public_path__ + "img/plus-purple-circle.f7d97fda.svg";